import 'stylesheets/industries_deferred.css';
import 'common';
import 'components/hamburger_mobile_menu';

import(/* webpackChunkName: "AddressSearchForm" */ 'address_search_form').then(module =>
  new module.AddressSearchForm().mount(),
);

const initLiberty = function () {
  import(/* webpackChunkName: "Liberty" */ 'liberty').then(module => new module.Liberty().mount());
};

document.body.addEventListener('click', initLiberty);
document.body.addEventListener('scroll', initLiberty);
